/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { CopilotMessageState, CopilotMessageSlots } from './CopilotMessage.types';

/**
 * Render the final JSX of CopilotMessage
 */
export const renderCopilotMessage_unstable = (state: CopilotMessageState): JSXElement => {
  assertSlots<CopilotMessageSlots>(state);

  return (
    <state.root>
      <div className={state.nameLineClassName}>
        {state.accessibleHeading && <state.accessibleHeading />}
        <state.avatar />
        <state.name />
        {state.disclaimer && <state.disclaimer />}
      </div>
      {state.content && <state.content />}
      {state.footnote && <state.footnote />}
      {state.actions && <state.actions />}
      {state.progress && <state.progress />}
    </state.root>
  );
};
